import { ablakotBezar, ablakotNyit, dokumentumMegjelenites } from './dokumentum-ablak.ts';

/**
 * A szállítólevél okmányainak megnyitása. (3.0 / 5.6)
 *
 * **Az okmány HTML-jét a szerver adja** (`/api/szallitolevel/html`), mert
 * ugyanaz megy a nyomtatási képre, a megőrzött PDF-be és az e-mail
 * csatolmányába. Ha itt építenénk fel újra, a három idővel eltérne.
 *
 * A PDF-et is a szerver készíti: a „PDF" gomb a megőrzött példányt nyitja
 * meg (`/api/szallitolevel/:id/pdf`).
 */

/** A szerver által adott teljes HTML-ből a stíluslap és a törzs. */
function darabol(html: string): { css: string; torzs: string } {
  const css = /<style>([\s\S]*?)<\/style>/.exec(html)?.[1] ?? '';
  const torzs = /<body>([\s\S]*?)<\/body>/.exec(html)?.[1] ?? html;
  return { css, torzs };
}

/**
 * Egy vagy több okmány megnyitása nyomtatásra.
 *
 * Az ablak **még a kattintásban** nyílik (a böngésző csak így engedi), a
 * tartalom utána töltődik bele.
 */
export async function szlevNyomtatas(idk: number[]): Promise<void> {
  if (idk.length === 0) return;
  const w = ablakotNyit('');
  try {
    const valasz = await fetch(`/api/szallitolevel/html?idk=${idk.join(',')}`);
    if (!valasz.ok) throw new Error('Az okmány nem tölthető be.');
    const { css, torzs } = darabol(await valasz.text());
    dokumentumMegjelenites(w, idk.length > 1 ? `${idk.length} okmány` : 'Szállítólevél', torzs, css);
  } catch (h) {
    ablakotBezar(w);
    throw h;
  }
}

/** A megőrzött PDF megnyitása új lapon. */
export function szlevPdf(id: number): void {
  window.open(`/api/szallitolevel/${id}/pdf`, '_blank', 'noopener');
}

/**
 * Egy kiadás négy okmánya: átadási HSO, átadási moslék, összesítő és —
 * ha volt HSO — a fenntarthatósági nyilatkozat. (3.0 / 5.5)
 */
export async function kiadasOkmanyokAblak(kiadas_id: number): Promise<void> {
  const w = ablakotNyit('');
  try {
    const valasz = await fetch(`/api/szallitolevel/kiadas/${kiadas_id}/html`);
    if (!valasz.ok) throw new Error('Az okmányok nem tölthetők be.');
    const { css, torzs } = darabol(await valasz.text());
    dokumentumMegjelenites(w, 'Kiadás okmányai', torzs, css);
  } catch (h) {
    ablakotBezar(w);
    throw h;
  }
}

/** A kiadás okmányai PDF-ben. */
export function kiadasPdf(kiadas_id: number): void {
  window.open(`/api/szallitolevel/kiadas/${kiadas_id}/pdf`, '_blank', 'noopener');
}
